export default "__VITE_ASSET__e2b0d3e1__"